export default __webpack_public_path__ + "static/media/panRye.2a64da41.png";